/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Agent_Development_Autonomy_Title8Inputs */

const en_svc_ai_agent_development_autonomy_title8 = /** @type {(inputs: Svc_Ai_Agent_Development_Autonomy_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Task planning & tool use`)
};

const ar_svc_ai_agent_development_autonomy_title8 = /** @type {(inputs: Svc_Ai_Agent_Development_Autonomy_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تخطيط المهام واستخدام الأدوات`)
};

const bn_svc_ai_agent_development_autonomy_title8 = /** @type {(inputs: Svc_Ai_Agent_Development_Autonomy_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`টাস্ক প্ল্যানিং ও টুল ব্যবহার`)
};

const de_svc_ai_agent_development_autonomy_title8 = /** @type {(inputs: Svc_Ai_Agent_Development_Autonomy_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aufgabenplanung und Werkzeugnutzung`)
};

const es_svc_ai_agent_development_autonomy_title8 = /** @type {(inputs: Svc_Ai_Agent_Development_Autonomy_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Planificación de tareas y uso de herramientas`)
};

const fr_svc_ai_agent_development_autonomy_title8 = /** @type {(inputs: Svc_Ai_Agent_Development_Autonomy_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Planification des tâches et utilisation des outils`)
};

const pt_svc_ai_agent_development_autonomy_title8 = /** @type {(inputs: Svc_Ai_Agent_Development_Autonomy_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Planejamento de tarefas e uso de ferramentas`)
};

const zh_svc_ai_agent_development_autonomy_title8 = /** @type {(inputs: Svc_Ai_Agent_Development_Autonomy_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`任务规划和工具使用`)
};

const tr_svc_ai_agent_development_autonomy_title8 = /** @type {(inputs: Svc_Ai_Agent_Development_Autonomy_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Görev planlama ve araç kullanımı`)
};

const ru_svc_ai_agent_development_autonomy_title8 = /** @type {(inputs: Svc_Ai_Agent_Development_Autonomy_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Планирование задач и использование инструментов`)
};

const pl_svc_ai_agent_development_autonomy_title8 = /** @type {(inputs: Svc_Ai_Agent_Development_Autonomy_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Planowanie zadań i użycie narzędzi`)
};

/**
* | output |
* | --- |
* | "Task planning & tool use" |
*
* @param {Svc_Ai_Agent_Development_Autonomy_Title8Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_agent_development_autonomy_title8 = /** @type {((inputs?: Svc_Ai_Agent_Development_Autonomy_Title8Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Agent_Development_Autonomy_Title8Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_agent_development_autonomy_title8(inputs)
	if (locale === "bn") return bn_svc_ai_agent_development_autonomy_title8(inputs)
	if (locale === "de") return de_svc_ai_agent_development_autonomy_title8(inputs)
	if (locale === "es") return es_svc_ai_agent_development_autonomy_title8(inputs)
	if (locale === "fr") return fr_svc_ai_agent_development_autonomy_title8(inputs)
	if (locale === "pt") return pt_svc_ai_agent_development_autonomy_title8(inputs)
	if (locale === "zh") return zh_svc_ai_agent_development_autonomy_title8(inputs)
	if (locale === "tr") return tr_svc_ai_agent_development_autonomy_title8(inputs)
	if (locale === "ru") return ru_svc_ai_agent_development_autonomy_title8(inputs)
	if (locale === "pl") return pl_svc_ai_agent_development_autonomy_title8(inputs)
	return en_svc_ai_agent_development_autonomy_title8(inputs)
});
export { svc_ai_agent_development_autonomy_title8 as "svc_ai-agent-development_AUTONOMY_title" }